import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { ActionOwner, ActionOwnerData } from '../actions.model';
import { ACTION_EMPLOYEE_SEARCH_API } from './action-employee-search-api.token';
import { ActionOwnerApi } from './action-owner-api.token';

@Injectable({ providedIn: 'root' })
export class EmployeeSearchActionOwnerService implements ActionOwnerApi {
  private readonly _employeeSearch = inject(ACTION_EMPLOYEE_SEARCH_API);

  loadOwners(): Observable<ActionOwnerData> {
    return of({ owners: [], dependencyMessage: null });
  }

  resolveOwner(ownerId: string): Observable<ActionOwner | null> {
    return this._employeeSearch.queryEmployee(ownerId).pipe(
      map((response) => {
        const employee = response.payload.users.find(
          (candidate) => candidate.id === ownerId,
        );
        if (!employee) return null;
        const displayName = [employee.firstName, employee.lastName]
          .filter(Boolean)
          .join(' ')
          .trim();
        return {
          id: employee.id,
          displayName: displayName || employee.email || employee.id,
        };
      }),
      catchError(() => of(null)),
    );
  }
}
